import { render, staticRenderFns } from "./ReturnToTopButton.vue?vue&type=template&id=f1d7c6b8&scoped=true&"
import script from "./ReturnToTopButton.vue?vue&type=script&lang=ts&"
export * from "./ReturnToTopButton.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnToTopButton.vue?vue&type=style&index=0&id=f1d7c6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d7c6b8",
  null
  
)

export default component.exports